import {Autocomplete, FormControl, FormHelperText, TextField} from '@mui/material';
import {get, toString} from 'lodash';
import {FC, useMemo} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {useDaData} from '../../../hooks/useDaData';
import {renderNonOptionsText, validateAddress} from './utils';

export const AddressField: FC = () => {
  const {
    control,
    setValue,
    formState: {errors},
    resetField,
  } = useFormContext();
  const {handleChangeAddress, suggestions} = useDaData();

  const options = useMemo(() => suggestions.map((s) => s.unrestricted_value), [suggestions]);
  const addressError = toString(get(errors, 'address.message', ''));

  const handleAddressChange = (_: unknown, value: string) => {
    const foundAddress = suggestions.find((s) => s.unrestricted_value === value);
    setValue('address', foundAddress, {shouldValidate: true});
  };

  return (
    <Controller
      name="address"
      control={control}
      rules={{validate: validateAddress}}
      render={({field: {value}}) => (
        <FormControl fullWidth>
          <Autocomplete
            size="small"
            freeSolo
            filterOptions={(x) => x}
            onChange={handleAddressChange}
            options={options}
            value={get(value, 'unrestricted_value', '')}
            noOptionsText={renderNonOptionsText('Ничего не найдено')}
            onInputChange={(_, v) => handleChangeAddress(v)}
            renderInput={(params) => <TextField {...params} error={!!addressError} label="Адрес" />}
            onReset={() => resetField('address')}
          />
          <FormHelperText sx={{m: '4px 14px 0'}} error>
            {addressError}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
};
